// extracted by mini-css-extract-plugin
export default {"formBox":"ClassMember_formBox__idCKp","formBoxTitle":"ClassMember_formBoxTitle__3JVTS"};